<template>
    <div class="card plain">
        <div class="card-header p-4">
            <h4>{{$t('settings.projects')}}</h4>
            
            <!-- Left -->
            <el-button
                v-if="showButtonDelete"
                v-permission="[`DELETE_PROJECTS`]"
                type="info"
                class="pull-left mb-4 btn btn-default btn-round"
                @click="handleDelete()">
                <font-awesome-icon icon="minus" /> Eliminar
            </el-button>

            <el-button
                v-if="showChangeStage"
                v-permission="[`NEXT_STEP_PROJECT`]"
                type="info"
                class="pull-left mb-4 btn btn-default btn-round"
                @click="dialogStepVisible = true">
                <i class="el-icon-refresh-right" > </i> Cambiar etapa
            </el-button>
            
            <router-link
                v-if="showCreateButton"
                v-permission="[`CREATE_PROJECTS`]"
                :to="'/panel/settings/projects'"
                class="btn btn-default btn-round pull-right">
                <font-awesome-icon icon="plus"/> Agregar
            </router-link>
            <el-input placeholder="" v-model="search" class="input-with-select" clearable @input="handleInputSearch">
                <el-select v-model="select" slot="prepend" placeholder="Filter">
                    <el-option :label="$t( 'projects.' + col)" :value="col" v-for="col in colsName" :key="col.id">
                    </el-option>
                </el-select>
            </el-input>
            
        </div> 
        <div class="card-body">
            <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @sort-change="handleSortChange">
                <el-table-column
                    fixed
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column v-for="(col, i) in colsName" :key="getStepKeyUUID(i)"
                    sortable="custom"
                    with="100"
                    :prop="col"
                    @formatter="formatter"
                    :label="$t( 'projects.' + col)">
                    <template slot-scope="scope">{{ scope.row[col] }}</template>
                </el-table-column>
                <el-table-column 
                    v-for="(stage, s) in stages" :key="getStepKeyUUID(s)"
                    align="center"
                    :label="$t( 'projects.' + stage.name.toLowerCase())">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == stage.name" effect="dark" type="success"><i class="now-ui-icons el-icon-check"></i></el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label=""
                    width="120">
                    <template slot-scope="scope">
                        <router-link
                            v-permission="[`EDIT_PROJECTS`]"
                            v-if="showEditButton"
                            :to="'/panel/settings/projects/' + scope.row.id">
                            <i style="font-size: 24px !important;" class="el-icon-edit-outline"></i>
                        </router-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-footer p-3 m4">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pagination.per_page"
                :page-count="pagination.current_page"
                layout="total, prev, pager, next, sizes"
                :total="pagination.total"
                @size-change="handleChangeSizePage"
                >
            </el-pagination>
        </div>

        <el-dialog
        :title="'Etapa actual ' + (multipleSelection.length > 0 ? getStageName(multipleSelection[0].stage_id) : '')"
        :visible.sync="dialogStepVisible"
        width="30%">
            <h6>Cambiar a</h6>
            <el-select v-model="stageSelected" placeholder="Selecciona la etapa">
                <el-option
                v-for="s in stagesNotIn()"
                :key="s.id"
                :label="s.name"
                :value="s.id">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogStepVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="handleChangeStage">Confirmar</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import { Table, TableColumn, Pagination,
Button, Input, Select, Option, MessageBox,
Message, Drawer, Tag, Progress, Dialog } from 'element-ui';
import { log } from 'util';
import _ from 'lodash'

import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Progress.name]: Progress,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        [Input.name]: Input,
        [Pagination.name]: Pagination,
        [Drawer.name]: Drawer,
        [Tag.name]: Tag,
        [Dialog.name]: Dialog,
    },
    props: {
      filters: {
          String
      },
      sotkey: {
          String
      }
    },
    computed: {
        colsName() {
            let cols = _.find(this.columns, function(c) { return c.name == 'projects' })
            return cols.data
        },
        showButtonDelete() {
            return this.multipleSelection.length > 0
        },
        showChangeStage () {
            return this.multipleSelection.length == 1
        },
        idSelected() {
            return this.multipleSelection.length > 0 ? this.multipleSelection[0].id : null
        },
        showEditButton() {
            return true
        },
        showCreateButton() {
            return true
        }
    },
    mounted() {
        this.loadData()
        this.getStages()
    },
    data() {
      return {
        showPanel: true,
        select: 'name',
        columns: [
            { 
              name: 'projects',
              data: [
                'name',
                'ammount_total',
                'ammount_recauded'
              ]
            }
        ],
        tableData: [],
        multipleSelection: [],
        pagination: {
          current_page: 1,
          per_page: 10,
          total: 0
        },
        search: '',
        sort: `sort[${this.sotkey || 'id'}]=desc`,
        loading: false,
        stages: [],
        dialogStepVisible: false,
        stageSelected: null
      }
    },
    methods: {
        loadData() {
            this.loading = true
            let filters = _.clone(this.filters) || ''
            let inputSearch = _.clone(this.search)
            if(inputSearch){
                if (filters && filters.trim() != '') {
                    filters += '&f[' + this.select + ']=' + inputSearch
                }else {
                    filters += 'f[' + this.select + ']=' + inputSearch
                }
            }
            provider.getData('projects', this.pagination.per_page, this.pagination.current_page, this.sort, filters).then((response) => {
                this.tableData = response.data.data
                this.pagination = response.data.meta.pagination
                this.loading = false
            }).catch((err) => {
                console.info('error data request')
                console.info(err)
                this.loading = false
            })
        },
        getStages() {
            provider.getData('stages', 50, 1).then((response) => {
                let data = response.data.data
                this.stages = data
            }).catch((err) => {
                console.info('error get stages request')
                console.info(err)
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSortChange(sortConfig){
            let order = sortConfig.column.order == 'descending' ? 'desc' : 'asc'
            let prop = sortConfig.column.property
            this.sort = 'sort['+ prop + ']=' + order
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.current_page = val
            this.loadData()
        },
        handleEdit(index, row) { },
        handleDelete(index, rows) {
            let idSelected = _.map(this.multipleSelection, (ob)=>{
                return ob.id
            });
            if(idSelected.length > 0) {
                MessageBox.confirm(`Esto eliminará el proyecto. ¿Continuar?`,
                "Confirmation",
                {
                    confirmButtonText: "Continuar",
                    cancelButtonText: "No",
                    type: "warning"
                }).then(() => {
                    this.loading = true
                    provider.deleteRow('projects', idSelected).then((response) => {
                        Message({ type: 'success', message: 'Operación exitosa', effect: "dark" })
                        this.loadData()
                    }).catch((err) => {
                        console.info('error delete request')
                        console.info(err)
                        Message({ type: 'error', message: 'An error ocurred' })
                        this.loading = false
                    })
                }).catch(()=>{
                    this.loading = false
                })
            }
        },
        handleInputSearch() {
            this.loadData()
        },
        handlePermissions() {
            let id = this.multipleSelection[0].id
            this.$router.push('settings/assign/' + id)
        },
        handleChangeStage() {
            this.dialogStepVisible = false
            let stageName = this.getStageName(this.stageSelected)
            MessageBox.confirm(`¿Cambiar a la etapa ${stageName}?`,
            "Confirmación",
            {
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                type: "warning"
            }).then(() => {
                let stage_id = this.stageSelected
                let id = this.multipleSelection[0].id
                let data = { stage_id: stage_id }
                provider.changeStage(id, data).then((response) => {
                    Message({ type: 'success', message: 'Operación exitosa' })
                    this.loadData()
                }).catch((err) => {
                    console.info('error change step request')
                    console.info(err)
                    Message({ type: 'error', message: 'An error ocurred' })
                    this.loading = false
                })
            }).catch(() => {})
        },
        handleChangeSizePage (val) {
            this.pagination.per_page = val
            this.loadData()
        },
        getStageName(id){
            let stageName = ''
            if(this.stages.length > 0) {
                for (let i = 0; i < this.stages.length; i++) {
                    const s = this.stages[i]
                    if (s.id == id) {
                        stageName = s.name
                    }
                }
            }
            return stageName
        },
        formatter(row, column){
            return row
        },
        getStepKeyUUID (index) {
            return Math.random() + index
        },
        stagesNotIn () {
            let stagesDiff = []
            let id = this.multipleSelection.length > 0 ? this.multipleSelection[0].stage_id : null
            if (id) {
                stagesDiff = _.filter(this.stages, (s)=> {
                    return s.id !== id
                })
            }
            return stagesDiff
        }
    },
    watch: {
        filters(){
            this.loadData()
        },
        paginationIdx(){
            this.loadData()
        },
        selectAll() {
            if(!_.isEmpty(this.dataArray)) {
                _.each(this.dataArray, (v)=> {
                v.selected = this.selectAll
                })
                this.showMenuValue = this.selectAll
            }
        }
    }
};
</script>
<style>
.el-select .el-input {
    width: 110px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>
